import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, configGeneralsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, configGeneralsActions);

export default slice.reducer;
